export const state = () => ({
})

export const getters = {
}

export const mutations = {
}

export const actions = {
  async list() {
    const result = await this.$axios.get("https://etaxgateway.one.th/serviceconfig_template/getlistconfig_po")
    return result.data.message
  },
}
